import {
  approvalModalOptions,
  authenticateType,
  dateFilter,
  dateRanges,
  fieldsArray,
  filterIsActive,
  isActivetrigger,
  isActiveUser,
  levels,
  notificationsApprovals,
  notificationsType,
  notificationtIsActive,
  roles,
  rowStyle,
  sortBy,
  sortIsActive,
  tableIsActive,
  triggerActions,
  triggerApprovals,
  userPermission,
} from "./constant";

type NotificationType = {
  level: string;
  approval: string;
  isActive: boolean;
};

const isValidEmail = (email: string | undefined): boolean => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const generateLevels = (val: number) => {
  const levels = [
    { label: 'Admin', value: 'admin' },
    ...Array.from({ length: val }).map((_, index) => ({
      label: `Level ${index + 1}`,
      value: `level-${index + 1}`,
    })),
  ] as { label: string; value: string }[];

  return levels;
};

export const generateApprovalsArray = (
  setFieldValue: any,
  values: any,
  numberOfLevels: any
) => {
  let filteredApprovals = values.approvals.filter(
    (item: any) => parseInt(item.level.value.split("-")[1]) <= numberOfLevels
  );

  for (let i = filteredApprovals.length + 1; i <= numberOfLevels; i++) {
    filteredApprovals.push({
      username: "",
      role: roles[1],
      isActive: isActiveUser[0],
      level: {
        label: `Level ${i}`,
        value: `level-${i}`,
      },
      canUpload: isActiveUser[0],
      selectMode: "select-async",
      addNew: 1,
    });
  }

  let filteredAdmins = values.approvals.filter(
    (item: any) => item.level.value === "admin"
  );

  filteredAdmins.forEach((admin: any) => {
    filteredApprovals.unshift(admin);
  });

  setFieldValue("approvals", filteredApprovals);
};

export const transformResponse = (values: any) => {
  const transformedDateFilter = {
    ...values.dateFilter,
    showFilter: values.dateFilter.showFilter,
    range: values.dateFilter.range.value,
    rangeActive: values.dateFilter.rangeActive,
    filterKey: values.dateFilter.filterKey.value,
    rangeFilter: values.dateFilter.rangeFilter,
  };

  const transformedFileViewer = {
    ...values.fileViewer,
    isFile: values.fileViewer.isFile,
    isTable: values.fileViewer.isTable,
    isCurebay: values.fileViewer.isCurebay,
    editable: values.fileViewer.editable,
    show: values.fileViewer.show,
    tableFile: values.fileViewer.tableFile,
    showApprHistory: values.fileViewer.showApprHistory,
    approvalModalOption: values.fileViewer.approvalModalOption.value,
  };

  const transformedsortBy = values.sortBy ? values?.sortBy?.map((sort: any) => ({
    ...sort,
    mode: sort.mode?.value,
    key: sort.key?.value,
    isActive: sort?.isActive,
  })) : [];

  const transformedSearchFilterst = {
    ...values.searchFiter,
    isActive: values.searchFilter?.isActive,
    key: values.searchFilter?.key?.value,
  };

  const transformedFilters = values?.filters ? values?.filters?.map((filter: any) => {
    const { addNew, ...rest } = filter;
    return {
      ...rest,
      isActive: filter.isActive?.value,
      isMultiSelect: filter.isMultiSelect?.value,
      key: filter.key?.value,
      filters: filter.filters?.map((filter1: any) => ({
        ...filter1,
        isActive: filter1?.isActive,
        // key: filter1.key.value,
      })),
    };
  }) : [];


  let transformedApprovals = values.approvals.map((approval: any) => ({
    ...approval,
    isText: approval.username?.isText ? 1 : 0,
    addNew: approval.addNew ? 1 : 0,
    username:
      approval.selectMode === "select-async"
        ? Array.isArray(approval.username)
          ? approval.username[0].email
          : approval.username?.email
            ? approval.username?.email
            : approval.username?.email || approval?.username
        : approval.username?.email || approval?.username,
    isActive: approval.isActive.value,
    canUpload: approval?.canUpload?.value || false,
    role: approval.role.value,
    level: approval.role.value === "admin" ? "admin" : approval.level.value,
    userPermission: approval.userPermission || [],
  }));

  transformedApprovals = transformedApprovals.filter((approval: any) => {
    return isValidEmail(approval.username);
  });

  const transformedTriggers = values.triggers.map((trigger: any) => ({
    ...trigger,
    approval: trigger.approval.map((appr: any) => appr?.value),
    level: trigger.level.map((appr: any) => appr.value),
    isActive: trigger?.isActive.value || false,
    action: trigger?.action.value || "",
    authenticate: trigger?.authenticate || false,
    authType: trigger?.authType?.value || "",
    username: trigger?.username || "",
    password: trigger?.password || "",
    token: trigger?.token || "",
  }));

  const transformedNotification = values.notification
    .filter((notification: any) => notification?.level)
    .map((notification: any) => ({
      ...notification,
      approval: notification?.approval
        ?.map((appr: any) => appr?.value)
        .filter((value: any) => value !== null),
      level: notification?.level
        ?.map((appr: any) => appr?.value)
        .filter((value: any) => value !== null),
      isActive: notification?.isActive?.value || null,
      type: notification?.type || null,
    }))
    .filter((notification: any) =>
      (notification.approval?.length || 0) > 0 ||
      (notification.level?.length || 0) > 0
    );



  const transformedTable = values.table.map((item: any) => {
    const { addNew, ...rest } = item;
    return {
      ...rest,
      isActive: item.isActive.value,
      dateActive: item.dateActive,
      filterActive: item.filterActive,
      searchActive: item.searchActive,
      header: {
        ...item.header,
        label: item.header.label,
        isActive: item.header.isActive.value,
      },
      isPaginate: {
        ...item.isPaginate,
        paginationLimit: item.isPaginate.paginationLimit,
        isActive: item.isPaginate.isActive.value,
      },
      action: {
        ...item.action,
        view: item.action.view,
        edit: item.action.edit,
        delete: item.action.delete,
        downloadPDF: item.action.downloadPDF,
        downloadExcel: item.action.downloadExcel,
      },
      columnNameUpperCase: item?.columnNameUpperCase,
      columnName: item?.columnName?.map((column: any) => ({
        ...column,
        key: column.key,
        label: column.label,
        isActive: column.isActive,
        isFile: column.isFile,
        fileView: column.fileView,
        fileDownload: column.fileDownload,
        fieldType: column.fieldType,
        sortActive: column.sortActive,
        tooltipActive: column.tooltipActive,
        tooltipLabel: column.tooltipLabel,
        truncatedActive: column.truncatedActive,
        labelCenter: column.labelCenter,
        labelNoWrap: column.labelNoWrap,
        rowType: column.rowType?.value,
      })),
      drawerTable: item?.drawerTable?.map((drawer: any) => ({
        ...drawer,
        label: drawer.label,
        isActive: drawer.isActive,
        labelCenter: drawer.labelCenter,
        labelNoWrap: drawer.labelNoWrap,
        rowType: drawer.rowType.value,
      })),
    };
  });

  const transformedNewTab = values?.tab?.map((item: any) => ({
    ...item,
    isActive: item.isActive,
    url: item.url,
    label: item.label,
    icon: item.icon,
  }));

  // const transformedTable = values.table.map((item : any) => item.tableId)
  return {
    ...values,
    regions: values.regions?.value || (Array.isArray(values.regions) ? values.regions[0] : values.regions),
    poExtractionType: values.poExtractionType,
    bulkApproveApproval: values.bulkApproveApproval,
    bulkRejectApproval: values.bulkRejectApproval,
    withdrawalLevel: Array.isArray(values.withdrawalLevel) ? values.withdrawalLevel?.map((it: any) => it.value) : [],
    withdrawalApproval: Array.isArray(values.withdrawalApproval) ? values.withdrawalApproval?.map((it: any) => it.value) : [],
    updateFirstUserNotification: values.updateFirstUserNotification,
    differentiateFirstLevel: values.differentiateFirstLevel,
    fieldsToDisable: values.fieldsToDisable?.map((item: any) => item?.value),
    forwardDocument: values.forwardDocument,
    forwardDocumentLevel: values.forwardDocumentLevel?.map((item: any) => item?.value),
    canAdditionalDocument: values.canAdditionalDocument?.map((item: any) => item?.value),
    onboarding: values.onboarding,
    isPdf: values.isPDF,
    isWord: values.isWord,
    showUploadTab: values.showUploadTab,
    dateFilter: transformedDateFilter,
    fileViewer: transformedFileViewer,
    filters: transformedFilters,
    approvals: transformedApprovals,
    triggers: transformedTriggers,
    sortBy: transformedsortBy,
    searchFilter: transformedSearchFilterst,
    table: transformedTable,
    tab: transformedNewTab,
    notification: transformedNotification,
    selectedUserProfile: values.selectedUserProfile,
  };
};

export const generateEditInitialValues = (data: any, fieldsArray: any = []) => {
  let levels = generateLevels(data.levels || 3);

  data.poExtractionType = data.poExtractionType
  data.reset_to_level_1 = data.reset_to_level_1 || false
  data.processType = data.processType ? ({ label: data.processType, value: data.processType }) : { label: "nonPo", value: 'nonPo' }
  data.processName = data.processName ? ({ label: data.processName, value: data.processName }) : { label: "Domestic", value: 'domestic' }
  data.regions = (data.regions && (typeof data.regions === 'string' || (Array.isArray(data.regions) && data.regions.length > 0)))
    ? (typeof data.regions === 'string' ? { label: data.regions, value: data.regions } : { label: data.regions[0], value: data.regions[0] })
    : "";
  data.selectedUserProfile = data.selectedUserProfile || (data.processName?.value === "foreign" ? { email: data.workFlowName?.split("-")[0], id: data.workFlowName?.split("-")[0] } : undefined);
  data.canAdditionalDocument = data.canAdditionalDocument ? data.canAdditionalDocument?.map((item: any) => ({ label: item, value: item })) : []
  data.withdrawalApproval = Array.isArray(data.withdrawalApproval) ? data.withdrawalApproval?.map((it: any) => ({ label: it, value: it })) : [];
  data.withdrawalLevel = Array.isArray(data.withdrawalLevel) ? data.withdrawalLevel?.map((it: any) => ({ label: it, value: it })) : [];
  data.fieldsToDisable = Array.isArray(data.fieldsToDisable) ? data.fieldsToDisable?.map((it: any) => ({ label: it, value: it })) : [];
  data.forwardDocument = data.forwardDocument || false;
  data.forwardDocumentLevel = Array.isArray(data.forwardDocumentLevel) ? data.forwardDocumentLevel?.map((it: any) => ({ label: it, value: it })) : [];
  data.showAdditionalForm = Array.isArray(data.showAdditionalForm) ? data.showAdditionalForm.map((appr: any) => {
    const matchedApproval = levels.find((item: any) => item.value === appr);
    return matchedApproval;
  }) : []
  data.fileViewer = {
    show: data.fileViewer?.show,
    editable: data.fileViewer?.editable,
    tableFile: data.fileViewer.tableFile,
    approvalModalOption:
      approvalModalOptions.find(
        (item) => item.value === data?.fileViewer?.approvalModalOption
      ) || approvalModalOptions[0],
    showValue: data.fileViewer?.showValue,
    showApprHistory: data.fileViewer?.showApprHistory,
  };
  data.triggers = data.triggers?.map((item: any) => {
    return {
      ...item,
      approval:
        typeof item.approval === "string"
          ? []
          : item?.approval.map((appr: any) => {
            const matchedApproval = triggerApprovals.find(
              (item: any) => item.value === appr
            );
            return matchedApproval;
          }),
      level: item?.level.map((appr: any) => {
        const matchedApproval = levels.find((item: any) => item.value === appr);

        return matchedApproval;
      }),
      isActive:
        isActivetrigger.find((item: any) => item.value === item?.isActive) ||
        isActivetrigger[0],
      action:
        triggerActions.find((items: any) => items.value === item.action) ||
        triggerActions[0],
      authType:
        authenticateType.find((items: any) => items.value === item.authType) ||
        authenticateType[0],
    };
  });

  data.notification =
    data?.notification?.map((item: any) => {
      return {
        ...item,
        approval: item?.approval.map((appr: any) => {
          const matchedApproval = notificationsApprovals.find(
            (item: any) => item.value === appr
          );
          return matchedApproval || appr;
        }),
        level:
          typeof item.level === "string"
            ? []
            : item?.level && item?.level?.map((appr: any) => {
              const matchedApproval = levels.find(
                (item: any) => item.value === appr
              );
              return matchedApproval || appr;
            }),
        isActive:
          sortIsActive.find((items: any) => items.value === item.isActive) ||
          sortIsActive[0],
        type: item?.type || [],
      };
    }) || [];

  data.approvals = data.approvals?.map((approval: any) => ({
    ...approval,
    username: [{ id: approval.user, email: approval.username }],
    selectMode: "select-async",
    password: approval.password,
    isActive:
      isActiveUser.find((item: any) => item.value === approval.isActive) ||
      isActiveUser[0],
    canUpload:
      isActiveUser.find((item: any) => item.value === approval.canUpload) ||
      isActiveUser[1],
    role: roles.find((item: any) => item.value === approval.role) || roles[1],
    level:
      approval.role === "admin"
        ? roles[0]
        : levels.find((item: any) => item.value === approval.level) ||
        levels[0],
    userPermission: approval.userPermission || []
  }));

  data.sortBy = data.sortBy?.map((sort: any) => ({
    ...sort,
    isActive: sort?.isActive,
    key:
      fieldsArray.find((item: any) => item.value === sort?.key) ||
      fieldsArray[0],
    mode: sortBy.find((item) => item.value === sort?.mode) || sortBy[1],
  }));

  data.searchFilter = {
    key:
      fieldsArray.find((item: any) => item.value === data.searchFilter?.key) ||
      fieldsArray[0],
    isActive: data.searchFilter?.isActive,
  };

  data.dateFilter = {
    filterKey:
      dateFilter.find((item) => item.value === data.dateFilter?.filterKey) ||
      dateFilter[0],
    rangeActive: data.dateFilter?.rangeActive,
    range:
      dateRanges.find((item) => item.value === data.dateFilter?.range) ||
      dateRanges[0],
    showFilter: data.dateFilter?.showFilter,
    rangePicker: data.dateFilter?.rangePicker,
  };
  // data.bulkApproveApproval = data.bulkApproveApproval;
  // data.bulkRejectApproval = data.bulkRejectApproval;
  // data.documentType = data.documentType;
  data.updateFirstUserNotification = data.updateFirstUserNotification || false;
  data.onboarding = data.onboarding || false;
  data.differentiateFirstLevel = data.differentiateFirstLevel || false;

  data.filters = data.filters?.map((filter: any) => ({
    ...filter,
    isActive:
      filterIsActive.find((items: any) => items.value === filter?.isActive) ||
      filterIsActive[0],
    isMultiSelect:
      filterIsActive.find(
        (items: any) => items.value === filter?.isMultiSelect
      ) || filterIsActive[0],
    key:
      fieldsArray.find((item: any) => item.value === filter?.key) ||
      fieldsArray[0],
    filters: filter.filters?.map((item: any) => ({
      ...item,
      isActive: item.isActive,
    })),
  }));
  data.tab = data.tab?.map((tabItem: any) => ({
    ...tabItem,
    url: tabItem?.url,
    label: tabItem?.label,
    icon: tabItem?.icon,
    isActive: tabItem?.isActive,
  }));
  data.table = data.table?.map((item: any) => ({
    ...item,
    isActive:
      tableIsActive.find((items: any) => items.value === item?.isActive) ||
      tableIsActive[0],
    dateActive: item?.dateActive,
    filterActive: item?.filterActive,
    searchActive: item?.searchActive,
    header: {
      ...item.header,
      isActive:
        tableIsActive.find(
          (items: any) => items.value === item.header?.isActive
        ) || tableIsActive[0],
      label: item.header?.label || "",
    },
    isPaginate: {
      ...item.isPaginate,
      isActive:
        tableIsActive.find(
          (items: any) => items.value === item.isPaginate?.isActive
        ) || tableIsActive[0],
      paginationLimit: item.isPaginate?.paginationLimit || 20,
    },
    action: {
      ...item.action,
      view: item.action?.view,
      edit: item.action?.edit,
      delete: item.action?.delete,
      downloadPDF: item.action?.downloadPDF,
      downloadExcel: item.action?.downloadExcel,
    },
    columnNameUpperCase: item?.columnNameUpperCase,
    columnName: item.columnName?.map((column: any) => ({
      ...column,
      key: column?.key || "",
      label: column?.label || "",
      isActive: column?.isActive || false,
      isFile: column?.isFile,
      fileView: column?.fileView,
      fieldType: column?.fieldType,
      fileDownload: column?.fileDownload,
      sortActive: column?.sortActive,
      tooltipActive: column?.tooltipActive,
      tooltipLabel: column?.tooltipLabel || "",
      truncatedActive: column.truncatedActive,
      labelCenter: column.labelCenter,
      labelNoWrap: column.labelNoWrap,
      rowNoWrap: column.rowNoWrap,
      rowType:
        rowStyle.find((items: any) => items.value === column?.rowType) ||
        rowStyle[0],
    })),
    drawerTable: item.drawerTable?.map((drawer: any) => ({
      ...drawer,
      label: drawer?.label || "",
      isActive: drawer?.isActive || false,
      labelCenter: drawer.labelCenter,
      labelNoWrap: drawer.labelNoWrap,
      rowNoWrap: drawer.rowNoWrap,
      rowType:
        rowStyle.find((items: any) => items.value === drawer?.rowType) ||
        rowStyle[0],
    })),
  }));
  return data;
};

export const transformFields = (fields: any) => {
  return Object.keys(fields).map((key) => ({
    label: key.charAt(0).toUpperCase() + key.slice(1),
    value: key,
    type: fields[key].type,
  }));
};

export const updateWorkFlowInitialValues = (initialValues: any) => {
  return {
    ...initialValues,
    // table: initialValues.table.map((tableItem: any) => ({
    //   ...tableItem,
    //   columnName: fieldsArray.map((field: any) => ({
    //     ...tableItem.columnName[0],
    //     key: field.value,
    //     label: field.label,
    //     fieldType: field.type,
    //   })),
    // })),
  };
};

export const createNotificationArray = (levels: number) => {
  return [
    {
      level: generateLevels(levels),
      approval: notificationsApprovals,
      isActive: notificationtIsActive[0],
      type: ["email", "notification"],
    },
  ];
};
